/* lv-cena-kod (26.09.2026): po dodaniu do koszyka produktu z ceną "z kodem" (atrybut data-lv-kod na
   stronie) kod dodaje się sam do koszyka (/cart/update.js discount), z zachowaniem kodów już wpisanych. */
(function () {
  function kodyNaStronie() {
    var k = {};
    document.querySelectorAll('[data-lv-kod]').forEach(function (e) { if (e.dataset.lvKod) k[e.dataset.lvKod.toUpperCase()] = 1; });
    return Object.keys(k);
  }
  function dodajKody(kody) {
    if (!kody.length) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var jest = (c.discount_codes || []).map(function (d) { return (d.code || '').toUpperCase(); });
      var brak = kody.filter(function (k) { return jest.indexOf(k) === -1; });
      if (!brak.length) return;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: jest.concat(brak).join(',') }) }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }).catch(function () {});
  }
  var f = window.fetch;
  window.fetch = function (u) {
    var p = f.apply(this, arguments);
    try {
      var url = typeof u === 'string' ? u : u.url;
      if (/\/cart\/add/.test(url)) p.then(function (r) { if (r.ok) setTimeout(function () { dodajKody(kodyNaStronie()); }, 250); });
    } catch (e) {}
    return p;
  };
})();
/* 26.09.2026: klik w kod na karcie produktu = kopiowanie do schowka + komunikat "Kod skopiowany". */
(function () {
  function kopiuj(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function (ok) {
      var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.position = 'fixed'; a.style.opacity = '0';
      document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (e) {} a.remove(); ok();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lv-kopiuj]');
    if (!b) return;
    e.preventDefault();
    kopiuj(b.dataset.lvKopiuj).then(function () {
      var ok = b.querySelector('.lv-kod-chip__ok');
      if (ok) ok.textContent = 'Kod skopiowany';
      b.classList.add('is-skopiowany');
      clearTimeout(b._lvT);
      b._lvT = setTimeout(function () { b.classList.remove('is-skopiowany'); }, 2000);
    }).catch(function () {});
  });
})();
/* 26.09.2026: zegar konca promocji obok ceny (data-lv-zegar="RRRR-MM-DD", promocja trwa do konca tego dnia). */
(function () {
  function d2(n) { return n < 10 ? '0' + n : '' + n; }
  function start() {
    document.querySelectorAll('[data-lv-zegar]').forEach(function (z) {
      if (z._lvZ) return;
      var c = (z.dataset.lvZegar || '').split('-');
      if (c.length !== 3) return;
      var koniec = new Date(+c[0], +c[1] - 1, +c[2] + 1).getTime();
      var out = z.querySelector('.lv-zegar__czas');
      function tik() {
        var r = Math.floor((koniec - Date.now()) / 1000);
        if (r <= 0) { z.hidden = true; clearInterval(z._lvZ); return; }
        var d = Math.floor(r / 86400), h = Math.floor(r % 86400 / 3600), m = Math.floor(r % 3600 / 60), s = r % 60;
        out.innerHTML = (d > 0 ? '<b>' + d + '</b> ' + (d === 1 ? 'dzień' : 'dni') + ' ' : '') + '<b>' + d2(h) + ':' + d2(m) + ':' + d2(s) + '</b>';
        z.hidden = false;
      }
      tik(); z._lvZ = setInterval(tik, 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 26.09.2026: akordeony na karcie produktu (pod cena i zakladki na mobile) - otwarcie jednego zamyka poprzedni.
   Zamykamy klikiem w summary, zeby przeszlo przez animacje motywu (accordion-tab). */
(function () {
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var tab = d.closest('accordion-tab.product__accordion');
    if (!tab) return;
    var grupa = tab.closest('.product__info-container, .mobile-tabs-accordion');
    if (!grupa) return;
    grupa.querySelectorAll('accordion-tab.product__accordion > details[open]').forEach(function (inny) {
      if (inny === d) return;
      var s = inny.querySelector('summary');
      if (s) s.click();
      if (inny.open) inny.open = false;
    });
  }, true);
})();
